// TODO: New maps feature. Cloud styling https://developers.google.com/maps/documentation/cloud-customization/overview
const mapStyles = [
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "poi.medical",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "poi.attraction",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "poi.park",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "transit.station",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "transit.station.airport",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  },
  {
    featureType: "transit.station.bus",
    elementType: "labels",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "transit.station.rail",
    elementType: "labels",
    stylers: [{ visibility: "on" }]
  }
];

export default mapStyles;
